/* eslint-disable */
import { PremiumPaymentMode } from "@/common/data/quoteInterfaces";
import { TFunction } from "i18next";

export const sleep = (ms: number | undefined) =>
  new Promise((r) => setTimeout(r, ms));

// since array is zero-based
export const firstInsuredIndex = 0;
export const secondInsuredIndex = 1;

// selector options
export const smokingStatus = (t: TFunction) => [
  {
    value: true,
    label: t("smoker"),
  },
  {
    value: false,
    label: t("nonSmoker"),
  },
];

export const sex = (t: TFunction) => [
  {
    value: 1,
    label: t("male"),
  },
  {
    value: 2,
    label: t("female"),
  },
];

export const backDate = (t: TFunction) => [
  {
    value: true,
    label: t("yes"),
  },
  {
    value: false,
    label: t("no"),
  },
];

export const jointFirstToDieSelectOptions = (
  t: TFunction
) => [
  {
    value: true,
    label: t("yes"),
  },
  {
    value: false,
    label: t("no"),
  },
];

export const premiumModeOptions = (t: TFunction) => [
  {
    value: PremiumPaymentMode.Monthly,
    label: t("monthly"),
  },
  {
    value: PremiumPaymentMode.Annual,
    label: t("annual"),
  },
];

// url parameters
export const urlParams = {
  illustration: {
    term: {
      illustrationNumber: "illustrationNumber", // illustration number to retrieve data from DB
      returnAction: "returnAction" // DialogAdvisorCodeMode string representation, if present, need to update formik values with data saved in sessionStorage and do the action
    },
    ci: {
      illustrationNumber: "illustrationNumber",
      returnAction: "returnAction",
    },
  },
};

// Setting a static unique value for policy level insured for illustrative purposes. Since the insured ID could be in the range of [-1 to - 5], so setting it to - 11 to ensure uniqueness
export const PolicyLevelRiderInsuredId = -11;

export enum Language {
  en = "en",
  fr = "fr"
}

export const insuredDisability = 6;
export const maxNumberOfDigitsToInput = {
  two: 2,
  three: 3,
  ten: 10
}

export const sessionStorageItems = {
  formikValues: "formikValues"
};

export const noBreakSpace = "\u00A0";
export const emptyMessageToHighlightError = noBreakSpace;
export const debouncingTimeInMilliseconds = 1000;
export const minMonthsAgeToConvertTo1Year = 6;
export const DialogBoxActionButtonSxStyle = {
  width: "144px",
  Padding: "12px",
};

export const dateFormat = "YYYY-MM-DD";
export const emptyObject = {};
Object.freeze(emptyObject);

export const formatDataTestId = (name: string) => 
  name
  .toLowerCase()
  .replace(/[\s/]/g, '_')
  .replace(/[()]/g, '');
